<template>
  <div id="page-text-fields">

    <v-toolbar
      card
      dense
      color="transparent"
    >
      <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
      <v-btn
        color="primary"
        outline
      >Save & Close</v-btn>

      <v-btn icon>
        <v-icon>reply</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>delete</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>first_page</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>last_page</v-icon>
      </v-btn>
      <v-menu
        bottom
        left
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, i) in items"
            :key="i"
            click
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- <v-spacer></v-spacer> <v-btn color="primary" outline>Post</v-btn> -->
    </v-toolbar>
    <v-container fluid>
      <v-layout
        row
        wrap
      >
        <v-flex sm12>

          <div slot="widget-content">
            <v-layout
              row
              wrap
            >
              <p>Work Date Information</p>
            </v-layout>
            <v-layout row>
              <v-flex sm3>
                <v-text-field
                  label="Date"
                  :error-messages="errors.collect('Date')"
                  type="date"
                  required
                  prepend-icon="date_range"
                  v-model="form.Date"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  label="User"
                  prepend-icon="person"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-autocomplete                  
                  hint="Atleast 3 Characters required"                  
                  :loading="loader"
                  chips                 
                  flat
                  placeholder="Select only suggested Calender"
                  label="Calender"
                  prepend-icon="date_range"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm3>
                <v-autocomplete                  
                  hint="Atleast 3 Characters required"                  
                  :loading="loader"
                  chips                  
                  flat
                  placeholder="Select only suggested Country"
                  label="Country"
                  prepend-icon="filter_list"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex sm3>
                <v-autocomplete                  
                  hint="Atleast 3 Characters required"                  
                  :loading="loader"
                  chips                 
                  flat
                  placeholder="Select only suggested State"
                  label="State"
                  prepend-icon="filter_list"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm3>
                <v-subheader>
                  <v-icon>graphic_eq</v-icon>&nbsp;&nbsp;Enter for Period
                </v-subheader>
              </v-flex>
              <v-flex sm3>
                <v-autocomplete                 
                  hint="Atleast 3 Characters required"                  
                  :loading="loader"
                  chips                 
                  flat
                  placeholder="Select only suggested From Month"
                  :items="FromMonth"
                  v-model="form.FromMonthId"
                  @change="myFunction()"
                  label="From"
                  auto
                  chips
                  prepend-icon="insert_invitation"
                  color="blue"
                  item-text="name"
                  item-value="id"
                >

                </v-autocomplete>

              </v-flex>
              <v-flex sm3>
                <v-autocomplete                 
                  hint="Atleast 3 Characters required"                  
                  :loading="loader"
                  chips                  
                  flat
                  placeholder="Select only suggested To Month"
                  :items="ToMonth"
                  v-model="form.ToMonthId"
                  label="To"
                  auto
                  chips
                  prepend-icon="insert_invitation"
                  color="blue"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

          </div>

        </v-flex>

        <v-flex lg12>
          <WorkDate-Months></WorkDate-Months>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import WorkDateMonths from '@/components/widgets/list/WorkDateMonths';
export default {
  components: {
    VWidget,
    WorkDateMonths
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    items: [
      { title: 'Add to WorkDate' },
      { title: 'Update WorkDate' },
      { title: 'Delete Order' },
      { title: 'Publish this to WorkDate' },
      { title: 'Duplicate Order...' }
    ],
    saveCard: true,
    cardTypes: [
      {
        id: 1,
        name: 'Arun'
      },
      {
        id: 2,
        name: 'Cheng'
      }
    ],
    tags: [
      {
        id: 1,
        name: 'Software'
      },
      {
        id: 2,
        name: 'Hardware'
      }
    ],
    projects: [
      {
        id: 1,
        name: 'TMS'
      },
      {
        id: 2,
        name: 'DMS'
      }
    ],
    FromMonth: [
      {
        id: 1,
        name: 'January'
      },
      {
        id: 2,
        name: 'Febraury'
      },
      {
        id: 3,
        name: 'March'
      },
      {
        id: 4,
        name: 'April'
      },
      {
        id: 5,
        name: 'May'
      },
      {
        id: 6,
        name: 'June'
      },
      {
        id: 7,
        name: 'July'
      },
      {
        id: 8,
        name: 'Augest'
      },
      {
        id: 9,
        name: 'September'
      },
      {
        id: 10,
        name: 'October'
      },
      {
        id: 11,
        name: 'November'
      },
      {
        id: 12,
        name: 'December'
      }
    ],
    ToMonth: [
      {
        id: 1,
        name: 'January'
      },
      {
        id: 2,
        name: 'Febraury'
      },
      {
        id: 3,
        name: 'March'
      },
      {
        id: 4,
        name: 'April'
      },
      {
        id: 5,
        name: 'May'
      },
      {
        id: 6,
        name: 'June'
      },
      {
        id: 7,
        name: 'July'
      },
      {
        id: 8,
        name: 'Augest'
      },
      {
        id: 9,
        name: 'September'
      },
      {
        id: 10,
        name: 'October'
      },
      {
        id: 11,
        name: 'November'
      },
      {
        id: 12,
        name: 'December'
      }
    ],

    valid: true,
    form: {
      FromMonthId: 1,
      ToMonthId: 1,
      cardNumber: 'SW Task',
      description: 'SW Task',
      cardName: 'Mcihael Wang',
      cardTypeId: 1,
      Date: '2018-11-16',
      HolidayDate: '2018-11-16',
      TriggerDate: '2018-11-16',
      TaskDueDate: '2018-11-16',
      tagid: [1],
      projectid: 1
    }
  }),

  mounted () {
    this.$validator.localize('en', this.dictionary);
  },

  methods: {
    submit () {
      this.$validator.validateAll();
    },
    clear () {
      this.form = {};
      this.$validator.reset();
    },
    myFunction: function () {
      console.log(this.selected);
    }
  }
};
</script>


 


// WEBPACK FOOTER //
// src/pages/calendar/WorkDate.vue